import React, {Component} from "react";
import FlexView from "react-flexview";
import Button from "../../../../../../modules/commons/Button";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../../modules/SimpleInput";
import {ACTIVITY_TYPE} from "../../../../../common/Constants";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import * as R from "ramda";
import Api from "../../../../../../Services/Api";
import { defaultTableChange } from "../../../../../../modules/custom/customTable";

class MutasiDetailNoQrTab extends Component {
    constructor(props) {
        super(props);
        this.tabHadiah = props.tab === "hadiah";
        this.kodeKey = this.tabHadiah ? "kodeHadiah" : "kodeOtherItem";
        this.dtoKey = this.tabHadiah ? "masterGiftDTO" : "masterOtherItemDTO";
        this.categoryKey = this.tabHadiah ? "categoryHadiah" : "categoryOtherItem";
        this.nameKey = this.tabHadiah ? "namaHadiah" : "nameOtherItem";
        this.dataName = this.tabHadiah ? "mutationGifts" : "mutationOthers";
        this.name = this.tabHadiah ? "masterGiftDTO.namaHadiah" : "masterOtherItemDTO.nameOtherItem";
        this.tableColumns = [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, {rowIndex}) =>
                        <p className={this.props.state.data[this.dataName][rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                            {rowIndex + 1}
                        </p>,
                    setCellProps: () => ({
                        style: {width: "5%"},
                    }),
                },
            },
            {
                name: this.kodeKey,
                options:
                    {
                        customHeadRender: (props) => (
                            <th key={props.index} className="custom-locator padding-right-15px">
                                <p style={{display: "flex"}}>
                                    {this.props.mutasiKeluarTab ? (
                                        <>
                                            {this.tabHadiah ? "Kode Hadiah" : "Kode Barang"}
                                            <span style={{color: "red"}}>*</span>
                                        </>
                                    ) : (
                                        <>{this.tabHadiah ? "Kode Hadiah" : "Kode Barang"}</>
                                    )}
                                </p>
                            </th>
                        ),
                        customBodyRender:
                            (val, {rowIndex}) => (
                                <>
                                    {this.props.mutasiKeluarTab ? (
                                        <SimpleDDL
                                            id="select_options_kode_varian"
                                            name={this.kodeKey}
                                            box="search"
                                            styles={{
                                                menu: (provided) => ({
                                                    ...provided,
                                                    position: "relative",
                                                    fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                                                }),
                                            }}
                                            containerclassname="margin-bottom-none"
                                            readOnly={this.props.state.data[this.dataName][rowIndex].saved}
                                            options={
                                                this.tabHadiah
                                                    ? this.props.state.kodeHadiahOptions.filter(item => item.qrHadiah === false)
                                                    : this.props.state.kodeBarangLainOptions.filter(item => item.qrotheritem === false)
                                            }
                                            value={val}
                                            onChange={(value, {name}) => {
                                                if(this.props.state.data[this.dataName].find(item => item[this.kodeKey]?.value === value?.value)){
                                                    this.props.onSetState(prev=>({
                                                        ...prev,
                                                        alertVisible: !prev.alertVisible,
                                                        warningMessage: `${value?.value} Sudah Digunakan`
                                                    }))
                                                    return
                                                }
                                                this.props.onSetState((prevValue) => ({
                                                    ...prevValue,
                                                    data: {
                                                        ...prevValue.data,
                                                        [this.dataName]: prevValue.data[this.dataName].map((d, idx) =>
                                                            idx === rowIndex
                                                                ? {
                                                                    ...d,
                                                                    [name]: value,
                                                                    [this.dtoKey]: {
                                                                        [this.categoryKey]: value.category,
                                                                        [this.nameKey]: value.name,
                                                                    },
                                                                    satuan: value.satuan,
                                                                }
                                                                : d
                                                        ),
                                                    },
                                                }));
                                            }}
                                        />
                                    ) : (
                                        <p className={this.props.state.data[this.dataName][rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                            {val.label}
                                        </p>
                                    )}
                                </>
                            ),
                        setCellProps:
                            () => ({
                                style: {width: "100px"},
                            }),
                    }
                ,
            }
            ,
            {
                name: this.name,
                label:
                    this.tabHadiah ? "Nama Hadiah" : "Nama Barang Lain",
                options:
                    {
                        customBodyRender: (val, {rowIndex}) => (
                            <p className={this.props.state.data[this.dataName][rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                {val}
                            </p>
                        ),
                        setCellProps:
                            () => ({
                                style: {width: "200px"},
                            }),
                    }
            }
            ,
            {
                name: this.tabHadiah
                    ? "masterGiftDTO.categoryHadiah"
                    : "masterOtherItemDTO.categoryOtherItem",
                label:
                    "Kategori",
                options:
                    {
                        customBodyRender: (val, {rowIndex}) => (
                            this.tabHadiah ? (
                                <p className={this.props.state.data.mutationGifts[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                    {val}
                                </p>
                            ) : (
                                <p className={this.props.state.data.mutationOthers[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                    {val}
                                </p>
                            )
                        )
                    }
            }
            ,
            {
                name: "qty",
                options:
                    {
                        customHeadRender: (props) => (
                            <th key={props.index} className="custom-locator padding-right-15px">
                                <p style={{display: "flex"}}>
                                    {this.props.mutasiKeluarTab ? (
                                        <>
                                            Qty<span style={{color: "red"}}>*</span>
                                        </>
                                    ) : (
                                        "Qty"
                                    )}
                                </p>
                            </th>
                        ),
                        customBodyRender:
                            (val, {rowIndex}) => (
                                <>
                                    {this.props.mutasiKeluarTab ? (
                                        <SimpleInput
                                            id="input_text_qty"
                                            name="qty"
                                            box="onlyNumber"
                                            containerclassname="margin-bottom-none"
                                            value={val}
                                            readOnly={this.props.state.data[this.dataName][rowIndex].saved}
                                            onChange={({target}) => this.handleChangeQty(rowIndex, target.value)}
                                        />
                                    ) : (
                                        this.tabHadiah ? (
                                            <p className={this.props.state.data.mutationGifts[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                                {val || 0}
                                            </p>
                                        ) : (
                                            <p className={this.props.state.data.mutationOthers[rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                                {val || 0}
                                            </p>
                                        )
                                    )
                                    }
                                </>
                            ),
                        setCellProps:
                            () => ({
                                style: {width: "100px"},
                            }),
                    }
                ,
            }
            ,
            {
                name: "satuan",
                label:
                    "Satuan",
                options:
                    {
                        customBodyRender: (val, {rowIndex}) => (
                            <p className={this.props.state.data[this.dataName][rowIndex].status === "REJECTED" ? "color-red" : "color-black"}>
                                {val}
                            </p>
                        )
                    }
            }
            ,
        ]
        ;

        if (this.props.mutasiKeluarTab) {
            this.tableColumns.push({
                name: "saved",
                label: "Aksi",
                options: {
                    customBodyRender: (val, {rowIndex}) => {return this.addDetailButton(val, rowIndex)},
                    setCellProps: () => ({
                        style: {width: "5%"},
                    }),
                },
            });
        } else {
            this.tableColumns.splice(5, 0, {
                name: "receivedQty",
                label: "Qty Terima*",
                options: {
                    customBodyRender: (val, {rowIndex}) => (
                        <SimpleInput
                            id="input_text_qty_terima"
                            name="qtyterima"
                            box="onlyNumber"
                            value={val}
                            readOnly={!(this.props.state.data.mutationStatus === "WAITING_APPROVAL" || this.props.state.activityType === ACTIVITY_TYPE.CREATE || this.props.state.activityType === ACTIVITY_TYPE.UPDATE)}
                            onChange={({target}) => this.handleChangeReceivedQty(rowIndex, target.value)}
                        />
                    ),
                    setCellProps: () => ({
                        style: {width: "100px"},
                    }),
                },
            });
            this.tableColumns.push({
                name: "status",
                label: "Aksi",
                options: {
                    customBodyRender: (val, {rowIndex}) => {return this.addDetailButton(val, rowIndex)},
                    setCellProps: () => ({
                        style: {width: "5%"},
                    }),
                },
            });
        }

        this.state = {
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        }
    }

    handleChangeReceivedQty = (index, value) => {
        let qty = !R.isNil(value) && !R.isEmpty(value) ? parseInt(value) : null;
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [this.dataName]: prevValue.data[this.dataName].map((data, idx) =>
                    idx === index ? {...data, receivedQty: qty} : data
                ),
            },
        }));
    }

    handleReject = (index) => {
        let obj = this.props.state.data[this.dataName].filter((a, idx) => {
            if (idx === index) {
                a.status = a.status !== "REJECTED" ? "REJECTED" : a.status = "RECEIVED" ? "RECEIVED" : "ONPROGRESS";
                a.receivedQty = a.status === "REJECTED" ? 0 : a.receivedQty;
            }
            return a;
        });
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [this.dataName]: obj,
            }
        }));
    }

    handleChangeQty = (index, value) => {
        let qty = !R.isNil(value) && !R.isEmpty(value) ? parseInt(value) : null
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [this.dataName]: prevValue.data[this.dataName].map((data, idx) =>
                    idx === index ? {...data, qty: qty} : data
                ),
            },
        }));
    };

    handleAdd = () => {
        if (this.props.state.data.mutationSourceKodeLocator !== null) {
            const newRow = {
                [this.kodeKey]: null,
                [this.nameKey]: "",
                [this.dtoKey]: {
                    [this.nameKey]: "",
                    [this.categoryKey]: "",
                },
                qty: 1,
                oldQty: 0,
                satuan: "",
                saved: false,
            };

            this.props.onSetState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    [this.dataName]: [...prevValue.data[this.dataName], newRow],
                },
            }));
        } else {
            this.props.onSetState(prev=>({
                ...prev,
                alertVisible: true,
                warningMessage: "No Locator Detected"
            }));
        }
    };

    validateItem = async (index) =>{
       try {
        const request = {
            nameCategory: this.tabHadiah ? "GIFT" : "OTHER",
            kodeCabang: this.props.state.data.mutationSourceKodeCabang.value,
            kodeLocator: this.props.state.data.mutationSourceKodeLocator.value,
            itemCode : this.props.state.data[this.dataName][index][this.kodeKey]?.value,
            previousTotal: this.props.state.data[this.dataName][index]?.oldQty,
            newTotal: this.props.state.data[this.dataName][index]?.qty,
        }
        const response = await Api.create("NAGAMAS_TRANSACTION").checkQtyMutasiHadiahDanBarangLain(request);
        if(response.ok && response.data.data){
            return 'Barcode Ditemukan'
        }
        return null
       } catch (error) {
        return null
       }
    }

    handleSaveRow = async (index, isNeedValidate) => {
        if(this.props.mutasiKeluarTab && isNeedValidate){
            const validateResult = await this.validateItem(index)
            if(validateResult===null){
                this.props.onSetState(prev=>({
                    ...prev,
                    alertVisible: !prev.alertVisible,
                    warningMessage: "Barang tidak dapat dimutasi karena stok tidak ada atau kuantitas stok tidak cukup"
                }))
                return
            }
        }

        this.props.onSetState((prevValue) => {
            const newState = [...prevValue.data[this.dataName]];
            newState[index] = {
                ...newState[index],
                saved: !newState[index].saved,
            };

            if (!this.validDetail(newState[index])) {
                return {
                    ...prevValue,
                    alertVisible: !prevValue.alertVisible,
                    warningMessage: "Ada field data yang perlu diisi atau tidak sesuai kriteria isian. Mohon periksa kembali.",
                }
            }

            return {
                ...prevValue,
                data: {
                    ...prevValue.data,
                    [this.dataName]: newState,
                },
            };
        });
    };

    validDetail = (obj) => {
        const column = [this.kodeKey, "qty"];
        for (const [key, data] of Object.entries(obj)) {
            if (column.includes(key) && R.or(R.isNil(data), !data, R.isEmpty(data))){
                return false;
            }
        }

        return true;
    }

    handleDeleteRow = (index) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {
                ...prevValue.data,
                [this.dataName]: prevValue.data[this.dataName].filter((_, idx) => idx !== index),
            },
        }));
    };

    addUnitButton = () => {
        if (this.props.mutasiKeluarTab) {
            if (this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return (
                    <>
                        <SimpleButton
                            icon={<i className="fa fa-plus margin-right-10px"></i>}
                            text="Tambah"
                            secondary={this.props.buttonType == "delete" || this.props.buttonType == "preview"}
                            disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}
                            onClick={this.handleAdd}
                        />
                    </>
                )
            }
        }
    }

    addDetailButton = (val, rowIndex) => {
        if (this.props.mutasiKeluarTab) {
            if (this.props.state.data.mutationStatus === "NEW" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return (
                    <>
                        <FlexView vAlignContent="center">
                            <Button className="btnAct" onClick={() => this.handleSaveRow(rowIndex, !val)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                                    <span
                                        style={{
                                            backgroundColor: "transparent",
                                            color: this.props.buttonType == "delete" || this.props.buttonType == "preview" ? "grey" : "red",
                                            fontSize: 20,
                                        }}
                                    >
                                      {!val ? <i className="fa fa-save"/> : <i className="fa fa-lw fa-pencil-alt"/>}
                                    </span>
                            </Button>
                            <Button className="btnAct margin-left-15px" onClick={() => this.handleDeleteRow(rowIndex)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                                <i
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: this.props.buttonType == "delete" || this.props.buttonType == "preview" ? "grey" : "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                        </FlexView>
                    </>
                )
            }
        } else {
            if (this.props.state.data.mutationStatus === "PROCESSED" || this.props.state.activityType === ACTIVITY_TYPE.CREATE) {
                return (
                    <>
                        <Button className="btnAct margin-left-15px" onClick={() => this.handleReject(rowIndex)} disabled={this.props.buttonType == "delete" || this.props.buttonType == "preview"}>
                            <span style={{ position: 'relative', fontSize: 20, display: 'inline-block' }}>
                                <i
                                  className="fas fa-hand-paper"
                                  style={{
                                    color:
                                      val === "REJECTED" || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                                        ? "black"
                                        : "red",
                                  }}
                                />
                                <i
                                  className="fas fa-slash"
                                  style={{
                                    position: 'absolute',
                                    top: 2.5,
                                    left: 0,
                                    color:
                                      val === "REJECTED" || this.props.buttonType == "delete" || this.props.buttonType == "preview"
                                        ? "black"
                                        : "red",
                                  }}
                                />
                            </span>
                        </Button>
                    </>
                )
            }
        }
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <>
                <FlexView vAlignContent="center" className="margin-bottom-10px" style={{gap: "10px"}}>
                    <h4>{this.tabHadiah ? "HADIAH" : "BARANG LAIN"}</h4>
                    {this.addUnitButton()}
                </FlexView>
                <SimpleDataTable
                    key={`${this.props.state.data[this.dataName]?.length}-${this.state.pagination.page}`}
                    data={this.props.state.data[this.dataName]}
                    columns={this.tableColumns}
                    toCount={this.props.state.data[this.dataName]?.length}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                />
            </>
        );
    }
}

export default MutasiDetailNoQrTab;
